import {Observable} from "rxjs";
import {ShipmentAddress} from "./+state/shipment-addresses.models";

export abstract class ShipmentAddressesServiceBase {

    public abstract getShipmentAddresses(shipmentId: string): Observable<ShipmentAddress[]>;

    public abstract updateShipmentAddress(
        shipmentId: string,
        shipmentAddressId: number,
        changes: Partial<ShipmentAddress>
    ): Observable<ShipmentAddress>

}
